<template>
	<div id="patient-container" class="screen" v-bind:class="`patient-container-${which}`">
		<div class="screen-container">
			<NavAmlCll
				v-bind:si="patients[which].si"
			/>
			<header class="container">
				<img id="patient-clinical-perspective" height="119" v-bind:src="require(`@/assets/patients/${which}/header/clinical-perspective.png`)" />
				<img id="patient-age-history" height="87" v-bind:src="require(`@/assets/patients/${which}/header/age-history.png`)" />
			</header>
			<nav id="patient-nav" class="container" v-bind:class="!showNav ? 'hide-nav': ''">
				<ul>
					<li v-for="navItem in patients[which].nav" v-bind:key="navItem">
						<!-- <router-link v-bind:to="navItem.link"> -->
						<span v-bind:class="path === navItem.link ? 'router-link-active': ''">
							{{navItem.title}}<sup v-if="navItem.sup">{{navItem.sup}}</sup>
						</span>
						<!-- </router-link> -->
					</li>
				</ul>
			</nav>
			<main class="container">
				<router-view />
			</main>
			<footer>
				<img id="footer-logo" width="81" height="14" src="../assets/global/footer-abbvie-logo.png" />
			</footer>
		</div>
	</div>
</template>
<script>
import NavAmlCll from '@/components/NavAmlCll'

export default {
	components: {
		NavAmlCll
	},
	data() {
		return {
			path: this.$route.fullPath,
			showNav: true,
			which: this.$route.params.which,
			patients: {
				bishop: {
					si: 'cll',
					nav: [
						{
							title: 'Diagnosis',
							link: '/patient/bishop/diagnosis/'
						},
						{
							title: 'Risk Assessment',
							link: '/patient/bishop/risk-assessment/',
							sup: 1
						},
						{
							title: 'Pre-initiation',
							link: '/patient/bishop/pre-initiation/',
							sup: 1
						},
						{
							title: 'Ramp-up',
							link: '/patient/bishop/ramp-up/',
							sup: 1
						}
					]
				},
				carson: {
					si: 'aml',
					nav: [
						{
							title: 'Diagnosis',
							link: '/patient/carson/diagnosis/'
						},
						{
							title: 'Cycle 1',
							link: '/patient/carson/cycle-1/'
						},
						{
							title: 'Cycle 2',
							link: '/patient/carson/cycle-2/'
						},
						{
							title: 'Cycle 3',
							link: '/patient/carson/cycle-3/'
						}
					]
				},
				gordon: {
					si: 'cll',
					nav: [
						{
							title: 'Diagnosis',
							link: '/patient/gordon/diagnosis/'
						},
						{
							title: 'Cycle 3',
							link: '/patient/gordon/cycle-3/'
						},
						{
							title: 'Cycle 4',
							link: '/patient/gordon/cycle-4/'
						}
					]
				},
				pierce: {
					si: 'aml',
					nav: [
						{
							title: 'Diagnosis',
							link: '/patient/pierce/diagnosis/'
						},
						{
							title: 'Pre-initiation',
							link: '/patient/pierce/pre-initiation/'
						},
						{
							title: 'Cycle 1',
							link: '/patient/pierce/cycle-1/'
						}
					]
				}
			}
		}
	},
	watch: {
		$route (to){
			this.path = to.fullPath
		}
	},
	updated() {
		if(this.$route.meta.hideNav === true || this.$route.name === 'final'){
			this.showNav = false
		} else {
			this.showNav = true
		}
	},
	created(){
		if(this.$route.meta.hideNav === true || this.$route.name === 'final'){
			this.showNav = false
		}
	}
}
</script>
<style scoped>
#patient-container {
	background: url(../assets/patients/background.png) no-repeat;
	background-size: cover;
}

	#patient-container .container {
		padding-right: 39px;
		padding-left: 39px;
	}

	#patient-container header {
		align-items: flex-end;
		margin-bottom: 24px;
	}

		#patient-clinical-perspective {
			margin-left: 51px;
		}

		#patient-age-history {
			margin-bottom: 16px;
		}

header {
	margin-top: 30px;
}

nav#patient-nav.hide-nav {
	display: none;
}

nav#patient-nav {
	margin-bottom: 16px;
}

nav#patient-nav ul,
nav#patient-nav li {
	display: flex;
	justify-content: center;
	align-items: center;
}

nav#patient-nav ul {
	background-color: #201545;
	border-radius: 9px;
	font-size: 16px;
	height: 38px;
	width: 100%;
}

	nav#patient-nav ul sup {
		font-size: 10px;
	}

nav#patient-nav li {
	border-left: 1px solid #9ca3b5;
	height: 25px;
	text-align: center;
	width: 100%;
}

	nav#patient-nav li:first-child {
		border-left: 0 none;
	}

	nav#patient-nav span {
		color: #fff;
		padding: 3px 15px;
		text-decoration: none;
		transition: all 180ms ease-in-out;
	}

	nav#patient-nav span.router-link-active {
		color: #24b6a2;
		font-weight: bold;
	}

#patient-container main {
	min-height: 386px;
	position: relative;
}

#patient-container footer {
	display: flex;
	justify-content: flex-end;
	position: fixed;
	right: 18px;
	bottom: 18px;
}
</style>